import {
  CakeSlice,
  Coffee,
  Cookie,
  CupSoda,
  Drumstick,
  Egg,
  Fish,
  Salad,
  Sandwich,
  Soup,
  Utensils,
  Wheat,
} from 'lucide-react';
import { ComponentType } from 'react';

interface ArtItem {
  icon: ComponentType<{ className?: string }>;
  x: number; // percentage left
  y: number; // percentage top
  rotation: number; // degrees
  size: number; // px
}

const MEAL_ART_ITEMS: ArtItem[] = [
  { icon: Soup, x: 8, y: 18, rotation: -12, size: 44 },
  { icon: Salad, x: 30, y: 62, rotation: 10, size: 36 },
  { icon: Fish, x: 52, y: 14, rotation: 18, size: 40 },
  { icon: Drumstick, x: 70, y: 58, rotation: -20, size: 34 },
  { icon: CupSoda, x: 88, y: 20, rotation: 8, size: 30 },
  { icon: Wheat, x: 16, y: 78, rotation: 24, size: 28 },
  { icon: Egg, x: 44, y: 84, rotation: -6, size: 24 },
  { icon: CakeSlice, x: 80, y: 86, rotation: 14, size: 28 },
  { icon: Coffee, x: 62, y: 34, rotation: -8, size: 22 },
  { icon: Utensils, x: 96, y: 54, rotation: -16, size: 26 },
  { icon: Cookie, x: 36, y: 30, rotation: 20, size: 20 },
  { icon: Sandwich, x: 4, y: 52, rotation: 6, size: 22 },
];

export interface MealArtProps {
  className?: string;
}

/**
 * Decorative ambient food outline icons scattered softly in the banner background.
 * Matches HR Module Prototype `.meal-art`.
 */
export const MealArt = ({ className = '' }: MealArtProps) => {
  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute inset-y-0 right-0 w-[45%] overflow-hidden opacity-35 transition-colors duration-200 sm:w-[48%] md:w-[42%] ${className}`}
    >
      {MEAL_ART_ITEMS.map((item, index) => {
        const IconComponent = item.icon;
        return (
          <span
            key={index}
            className="absolute block text-current"
            style={{
              left: `${item.x}%`,
              top: `${item.y}%`,
              width: `${item.size}px`,
              height: `${item.size}px`,
              transform: `translate(-50%, -50%) rotate(${item.rotation}deg)`,
            }}
          >
            <IconComponent className="h-full w-full stroke-[1.5]" />
          </span>
        );
      })}
    </div>
  );
};
